let listeners = [];

export default class UserPreferenceService {
    obj = null;

    get = (key) => {
        try {
            this.obj = this.obj || JSON.parse(localStorage.getItem('userPreferences'));
            return this.obj?.[key];
        } catch (error) {
            console.error('Error getting user preference: ', error);
            return undefined;
        }
    };

    set = (key, value) => {
        try {
            this.obj = this.obj || JSON.parse(localStorage.getItem('userPreferences')) || {};
            this.obj[key] = value;
            this.broadcastChange();
            localStorage.setItem('userPreferences', JSON.stringify(this.obj));
        } catch (error) {
            console.error('Error setting user preference: ', error);
        }
    };

    addChangeListener = (callback) => {
        if (typeof callback === 'function') {
            listeners.push(callback);
        }
    };

    removeChangeListener = (callback) => {
        listeners = listeners.filter((listener) => listener !== callback);
    };

    broadcastChange = () => {
        listeners.forEach((listener) => {
            try {
                listener(this.obj);
            } catch (e) {
                console.error('Error in preference change listener: ', e);
            }
        });
    };
}
